var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        version: "1.0",
        xmlns: "http://www.w3.org/2000/svg",
        width: "70px",
        height: "70px",
        viewBox: "0 0 296.000000 300.000000",
        preserveAspectRatio: "xMidYMid meet",
      },
    },
    [
      _c(
        "g",
        {
          attrs: {
            transform:
              "translate(0.000000,300.000000) scale(0.100000,-0.100000)",
            fill: "#000000",
            stroke: "none",
          },
        },
        [
          _c("path", {
            attrs: {
              d: "M1214 2989 c-248 -32 -495 -223 -589 -456 -23 -55 -26 -58 -72 -70\n-26 -7 -89 -32 -139 -57 -187 -93 -327 -264 -386 -473 -29 -101 -31 -285 -5\n-383 23 -86 79 -202 129 -269 l41 -54 -17 -74 c-9 -40 -16 -115 -16 -167 0\n-442 395 -795 834 -746 l79 9 64 -58 c73 -67 183 -128 293 -162 97 -31 298\n-33 400 -5 220 60 403 216 497 423 32 72 40 82 67 87 110 22 241 99 347 206\n71 71 94 103 133 181 64 131 80 199 80 344 0 176 -47 323 -145 453 l-40 53 15\n69 c9 38 16 113 16 168 0 347 -233 645 -575 733 -65 17 -104 20 -211 17 l-130\n-3 -54 48 c-112 101 -260 168 -414 187 -89 11 -113 11 -202 -1z m227 -203 c63\n-14 151 -53 213 -94 l28 -20 -23 -15 c-13 -8 -154 -90 -314 -181 -159 -92\n-298 -177 -307 -189 -16 -20 -18 -60 -18 -454 0 -238 -3 -433 -7 -433 -5 0\n-62 31 -128 69 l-120 68 -3 372 c-3 415 2 461 60 579 45 92 159 207 251 251\n119 58 243 73 368 47z m739 -238 c164 -35 333 -186 390 -350 27 -77 41 -182\n32 -240 l-7 -48 -310 182 c-261 153 -316 181 -350 181 -34 1 -92 -30 -385\n-200 -190 -110 -355 -205 -367 -212 l-23 -12 0 148 1 148 321 184 c176 101\n343 193 372 203 94 36 208 42 326 16z m-1610 -667 c0 -370 0 -370 23 -394 12\n-14 185 -118 385 -232 199 -115 361 -209 360 -211 -15 -13 -251 -145 -256\n-142 -5 2 -150 84 -323 183 -283 162 -322 187 -390 255 -123 121 -176 257\n-166 425 11 195 115 360 288 455 30 16 60 30 67 30 9 0 12 -80 12 -369z m1660\n14 c255 -147 305 -179 366 -240 176 -174 215 -432 98 -656 -53 -101 -162 -204\n-259 -245 l-35 -14 0 360 c0 294 -3 366 -14 389 -11 21 -106 80 -385 242 -204\n118 -371 217 -371 221 0 4 55 38 122 77 l122 71 31 -18 c16 -10 163 -94 325\n-187z m-610 -102 c74 -42 147 -85 163 -95 l27 -19 0 -178 c0 -157 -2 -180 -17\n-193 -22 -18 -300 -178 -311 -178 -4 0 -77 40 -162 89 l-155 88 -3 191 -2 190\n157 91 c87 50 160 91 163 91 2 0 65 -34 140 -77z m456 -264 l124 -71 0 -372\nc0 -417 -5 -461 -65 -583 -66 -134 -210 -248 -361 -288 -68 -18 -181 -20 -256\n-4 -56 12 -177 66 -216 97 l-24 18 304 174 c166 96 315 187 331 201 l27 27 0\n436 c0 240 3 436 6 436 4 0 62 -32 130 -71z m-268 -525 l-3 -147 -320 -185\nc-176 -102 -350 -196 -387 -208 -300 -107 -640 74 -723 386 -8 30 -15 95 -15\n144 0 80 2 88 17 81 10 -3 154 -85 320 -181 193 -111 313 -174 330 -174 18 0\n159 76 398 214 204 118 373 215 378 215 4 1 6 -65 5 -145z",
            },
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }